const f = {
  color: {
    divider: {
      charcoal: "#314351ff",
      clay: "#ded5d1ff",
      white: "#dfe6ebff"
    }
  }
};
export {
  f as floatingToolbar
};
